import { observable, action } from 'mobx';
import ApiCaller from '../utils/api-caller';
import moment from 'moment';

class BookingItemStore {

    // Properties

    // Modal Create/Update Properties

    @observable showBookingItemModal = false;
    @observable bookingItemTitle = '';
    @observable bookingItems = [];
    @observable bookingItemId = 0;
    @observable startTime = null;
    @observable endTime = null;
    @observable bookingCategoryId = 0;
    @observable bookingSubCategoryId = null;
    @observable bookingCategoryName = '';
    @observable bookingSubCategoryName = '';

    // Modal Search Category Properties

    @observable showBookingCategorySearchModal = false;
    @observable bookingCategories = [];
    @observable bookingCategoryFilter = [];
    @observable categorySearchValue = '';

    // Modal Search Sub Category Properties

    @observable showBookingSubCategorySearchModal = false;
    @observable bookingSubCategories = [];
    @observable bookingSubCategoryFilter = [];
    @observable subCategorySearchValue = '';

    // Helper Properties

    @observable bookingItemListLoading = false;
    @observable bookingItemModalLoading = false;

    // Initialization

    @action initBookingItem() {
        this.bookingItemListLoading = true;

        ApiCaller.BookingItems.getAll().then(responseFirst => {
            if (responseFirst && responseFirst.isSuccess) {
                this.bookingItems = responseFirst.model;

                ApiCaller.BookingCategories.getAll().then((responseSecond) => {
                    if (responseSecond && responseSecond.isSuccess) {
                        if (responseSecond.model.length > 0) {
                            this.bookingCategories = responseSecond.model;
                            this.bookingCategoryFilter = this.bookingCategories;

                            ApiCaller.BookingSubCategories.getAll().then((responseThird) => {
                                if (responseThird && responseThird.isSuccess) {
                                    if (responseThird.model.length > 0) {
                                        this.bookingSubCategories = responseThird.model;
                                        this.bookingSubCategoryFilter = this.bookingSubCategories;
                                        this.bookingSubCategoryFilter = this.bookingSubCategories.filter(item => {
                                            return (item.categoryId === this.bookingCategoryId);
                                        });
                                    }
                                }
            
                                this.bookingItemListLoading = false;
                            });
                        }
                    }
                });
            } else {
                this.bookingItems = [];
                this.bookingItemListLoading = false;
            }
        });
    }

    @action initCreateBookingItem() {
        this.bookingItemTitle = 'Create Booking Item';
        this.bookingItemId = 0;
        this.startTime = null;
        this.endTime = null;
        this.bookingCategoryName = '';
        this.itemTextButton = 'Create';
        this.showBookingItemModal = true;
    }

    @action initUpdateBookingItem(bookingItemId) {
        this.bookingItemModalLoading = true;
        this.bookingItemTitle = 'Update Booking Item';
        this.itemTextButton = 'Update Item';
        this.showBookingItemModal = true;

        ApiCaller.BookingItems.getById(bookingItemId).then(response => {
            if (response && response.isSuccess) {
                var model = response.model;
                this.bookingItemId = model.id;
                this.bookingCategoryId = model.bookingCategoryId;
                this.bookingCategoryName = model.bookingCategoryName;
                this.bookingSubCategoryId = model.bookingSubCategoryId;
                this.bookingSubCategoryName = model.bookingSubCategoryName;
                this.itemTextButton = 'Save';
                this.bookingItemModalLoading = false;

                if (model.startTime === null || model.startTime === '') {
                    this.startTime = null;
                } else {
                    this.startTime = moment(`${moment().format('YYYY-MM-DD')} ${model.startTime}`);
                }

                if (model.endTime === null || model.endTime === '') {
                    this.endTime = null;
                } else {
                    this.endTime = moment(`${moment().format('YYYY-MM-DD')} ${model.endTime}`);
                }

                this.searchSubCategory();
            }
        });
    }

    // TRANSACTION

    @action searchCategory() {
        this.bookingCategoryFilter = this.bookingCategories.filter(item => {
            let categoryName = item.name.toLowerCase();
            return categoryName.indexOf(this.categorySearchValue.toLowerCase()) !== -1;
        });
    }

    @action searchCategorySelected(categoryId) {
        const category = this.bookingCategories.find(x => x.id === categoryId);
        this.bookingCategoryId = categoryId;
        this.bookingCategoryName = category.name;

        this.searchSubCategory();
        this.bookingSubCategoryId = 0;
        this.bookingSubCategoryName = '';
    }

    @action searchSubCategory() {
        this.bookingSubCategoryFilter = this.bookingSubCategories.filter(item => {
            let subCategoryName = item.name.toLowerCase();
            return (subCategoryName.indexOf(this.subCategorySearchValue.toLowerCase()) !== -1) && (item.bookingCategoryId === this.bookingCategoryId);
        });
    }

    @action searchSubCategorySelected(subCategoryId) {
        const subCategory = this.bookingSubCategories.find(x => x.id === subCategoryId);
        this.bookingSubCategoryId = subCategoryId;
        this.bookingSubCategoryName = subCategory.name;
    }

    // Transaction Booking Item

    @action createBookingItem() {
        this.bookingItemModalLoading = true;

        let startTime = null;
        let endTime = null;

        if (this.startTime) {
            startTime = moment(this.startTime).format('HH:mm:00');
        }

        if (this.endTime) {
            endTime = moment(this.endTime).format('HH:mm:00');
        }

        if (startTime === null || endTime === null) {
            startTime = null;
            endTime = null;
        }

        const request = {
            'bookingCategoryId': this.bookingCategoryId,
            'bookingSubCategoryId': this.bookingSubCategoryId,
            'startTime': startTime,
            'endTime': endTime
        };

        return ApiCaller.BookingItems.create(request).then((response) => {
            this.bookingItemModalLoading = false;
            if (response && response.isSuccess) {
                this.showBookingItemModal = false;
                this.initBookingItem();
            }

            return response;
        });
    }

    @action updateBookingItem() {
        this.bookingItemModalLoading = true;

        let startTime = null;
        let endTime = null;

        if (this.startTime) {
            startTime = moment(this.startTime).format('HH:mm:00');
        }

        if (this.endTime) {
            endTime = moment(this.endTime).format('HH:mm:00');
        }

        if (startTime === null || endTime === null) {
            startTime = null;
            endTime = null;
        }

        const request = {
            'id': this.bookingItemId,
            'bookingCategoryId': this.bookingCategoryId,
            'bookingSubCategoryId': this.bookingSubCategoryId,
            'startTime': startTime,
            'endTime': endTime
        };

        return ApiCaller.BookingItems.update(request).then((response) => {
            this.bookingItemModalLoading = false;
            if (response && response.isSuccess) {
                this.showBookingItemModal = false;
                this.initBookingItem();
            }

            return response;
        });
    }

    @action deleteUpdateBookingItem(id) {
        this.bookingItemListLoading = true;

        return ApiCaller.BookingItems.delete(id).then((response) => {
            this.bookingItemListLoading = false;

            if (response && response.isSuccess) {
                this.initBookingItem();
            }

            return response;
        });
    }

    // SET Properties

    @action setShowBookingItemModal(value) {
        this.showBookingItemModal = value;
    }

    @action setShowBookingCategorySearchModal(value) {
        this.showBookingCategorySearchModal = value;
    }

    @action setShowBookingSubCategorySearchModal(value) {
        this.showBookingSubCategorySearchModal = value;
    }

    @action setCategorySearchValue(value) {
        this.categorySearchValue = value
    }

    @action setSubCategorySearchValue(value) {
        this.subCategorySearchValue = value
    }

    @action setStartTime(value) {
        if (value) {
            this.startTime = value;
        } else {
            this.startTime = null;
        }
    }

    @action setEndTime(value) {
        if (value) {
            this.endTime = value;
        } else {
            this.endTime = null;
        }
    }
}

export default new BookingItemStore()
